import React from 'react';
import { withLocalize } from "react-localize-redux";
import { isNullOrUndefined } from '../../store/storeFunctions';

class Number extends React.Component {
    render() {
        if(!isNullOrUndefined(this.props.value) && !isNaN(this.props.value)) {
            if(!isNullOrUndefined(this.props.fixed) && this.props.fixed === true)
                return this.props.value.toFixed(this.props.fractionDigits || 2);

            return this.props.value.toLocaleString(this.props.activeLanguage.code);
        }

        return null;
    }
}

export default withLocalize(Number);
